import { Course } from '../model/course';
import { JsonForms } from '@jsonforms/react';

import schema from '../schema/course/schema.json';
import uischema from '../schema/course/uischema.json';
import { materialCells, materialRenderers } from '@jsonforms/material-renderers';

import '../index.css';

import { AppDispatch } from '../reducers/store';
import { updateCourse } from '../reducers/courseSlice';
import { useDispatch } from 'react-redux';

import VideoFileUploadControl from './videofilecontrol';
import ImageFileControl from './imagefile';
import { rankWith, scopeEndsWith } from '@jsonforms/core';
  
export interface CourseProps {
    course: Course | null
}

export const CourseContentView = ({course} : CourseProps) => {
    const dispatch: AppDispatch = useDispatch();

    return (
        <JsonForms
            schema={schema}
            data={course}
            uischema={uischema}
            renderers={[
                ...materialRenderers,
                { 
                    // documentation: https://jsonforms.io/docs/tutorial/custom-renderers
                    tester: rankWith(2, scopeEndsWith('url')), 
                    renderer: VideoFileUploadControl
                },
                {
                    tester: rankWith(3, scopeEndsWith('articleText')),
                    renderer: ImageFileControl,
                },
            ]}
            cells={materialCells}
            onChange={({ data, errors }) => {
                let updatedCourse: Course = data as Course
                dispatch(updateCourse(updatedCourse));
            }}
        />
    );
};